import React from 'react'

function ImageReturn({ image }) {
    return (
        <div className="image mb-sm-5 mb-4">
            <img src={image} alt='' style={{ height: `50em`, width: `82em` }} className="ultraMonitor img-fluid radius-image-full" />
        </div>
    )
}

export default ImageReturn
